import React from 'react';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface Props {
  value: boolean | undefined | string;
  onValueChange: (value: boolean) => void;
}

function BooleanEditor({ value, onValueChange }: Props): JSX.Element {
  return (
    <Select
      input={<Input />}
      value={value === true || value === 'Ja' ? 'Ja' : 'Nein'}
      onChange={(event) => onValueChange(event.target.value === 'Ja')}
      style={{ width: '100%' }}
    >
      <MenuItem value="Ja">Ja</MenuItem>
      <MenuItem value="Nein">Nein</MenuItem>
    </Select>
  );
}

export default BooleanEditor;
